import { get, startCase } from 'lodash';
import { Schema } from '../models/analytics-api/schema.model';
import { QueryFilter } from './query-filter.model';

export class QueryFilterOption {
  constructor(
    public name: string,
    public type: string,
  ) {
  }

  get displayName() {
    return this.name;
  }
}
